import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=3868c402&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./css/partner.css?vue&type=style&index=0&id=3868c402&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868c402",
  null
  
)

export default component.exports